import React from 'react';
import StatCard from './StatCard';
import { imageUrl } from '../../utils';

interface Stat {
  value: string;
  label: string;
  icon?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

interface StatsGridProps {
  stats: Stat[];
}

const StatsGrid = ({ stats }: StatsGridProps) => {
  return (
    <div className="grid md:grid-cols-3 gap-8">
      {stats.map((stat, index) => (
        <StatCard
          key={index}
          value={stat.value}
          label={stat.label}
          icon={stat.icon ? imageUrl(stat.icon) : undefined}
          gradientFrom={stat.gradientFrom}
          gradientTo={stat.gradientTo}
        />
      ))}
    </div>
  );
};

export default StatsGrid;

